'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.listen = exports.filter = exports.off = exports.on = undefined;

var _on = require('./on');

var _on2 = _interopRequireDefault(_on);

var _off = require('./off');

var _off2 = _interopRequireDefault(_off);

var _filter = require('./filter');

var _filter2 = _interopRequireDefault(_filter);

var _listen = require('./listen');

var _listen2 = _interopRequireDefault(_listen);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.on = _on2.default;
exports.off = _off2.default;
exports.filter = _filter2.default;
exports.listen = _listen2.default;
exports.default = { on: _on2.default, off: _off2.default, filter: _filter2.default, listen: _listen2.default };


//////////////////
// WEBPACK FOOTER
// ./node_modules/.pnpm/dom-helpers@3.0.0/node_modules/dom-helpers/events/index.js
// module id = 74
// module chunks = 0